var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCheckboxMultipleLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10952_35755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 4.91683V2.25016C4.66659 2.07335 4.73682 1.90378 4.86185 1.77876C4.98687 1.65373 5.15644 1.5835 5.33325 1.5835H13.9999C14.1767 1.5835 14.3463 1.65373 14.4713 1.77876C14.5963 1.90378 14.6666 2.07335 14.6666 2.25016V10.9168C14.6666 11.0936 14.5963 11.2632 14.4713 11.3882C14.3463 11.5133 14.1767 11.5835 13.9999 11.5835H11.3333V14.2455C11.3333 14.6162 11.0339 14.9168 10.6619 14.9168H2.00459C1.9164 14.9169 1.82906 14.8996 1.74757 14.8659C1.66608 14.8322 1.59204 14.7828 1.52969 14.7204C1.46733 14.658 1.41788 14.584 1.38418 14.5025C1.35047 14.421 1.33316 14.3337 1.33325 14.2455L1.33525 5.58816C1.33525 5.2175 1.63459 4.91683 2.00659 4.91683H4.66659ZM5.99992 4.91683H10.6619C11.0326 4.91683 11.3333 5.21616 11.3333 5.58816V10.2502H13.3333V2.91683H5.99992V4.91683ZM9.99992 6.25016H2.66859L2.66659 13.5835H9.99992V6.25016ZM5.66859 12.2502L3.31125 9.89283L4.25392 8.95016L5.66859 10.3648L8.49659 7.53616L9.43925 8.47883L5.66859 12.2502Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10952_35755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.25)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxMultipleLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkbox-multiple-line.d5bc7e7eb460fb1d6d958173ca55eb60.svg";